export default {
    allowCopy: Boolean | Object, 
    altRowTemplate: String | Function, 
    autoBind: Boolean, 
    columnResizeHandleWidth: Number, 
    columns: Array, 
    columnMenu: Boolean | Object, 
    dataSource: Object | Array, 
    detailTemplate: String | Function, 
    editable: Boolean | Object, 
    excel: Object, 
    filterable: Boolean | Object, 
    groupable: Boolean | Object, 
    height: Number | String, 
    messages: Object, 
    mobile: Boolean | String, 
    navigatable: Boolean, 
    noRecords: Boolean | Object, 
    pageable: Boolean | Object, 
    pdf: Object, 
    persistSelection: Boolean, 
    reorderable: Boolean, 
    resizable: Boolean, 
    rowTemplate: String | Function, 
    scrollable: Boolean | Object, 
    selectable: Boolean | String, 
    sortable: Boolean | Object, 
    toolbar: Array, 

    // Events
    beforeEdit: Function, 
    cancel: Function, 
    cellClose: Function, 
    change: Function, 
    columnHide: Function, 
    columnMenuInit: Function, 
    columnMenuOpen: Function, 
    columnReorder: Function, 
    columnResize: Function, 
    columnShow: Function, 
    dataBinding: Function, 
    dataBound: Function, 
    detailCollapse: Function, 
    detailExpand: Function, 
    detailInit: Function, 
    edit: Function, 
    excelExport: Function, 
    filter: Function, 
    group: Function, 
    groupCollapse: Function, 
    groupExpand: Function, 
    page: Function, 
    pdfExport: Function, 
    filterMenuInit: Function, 
    filterMenuOpen: Function, 
    remove: Function, 
    save: Function, 
    saveChanges: Function, 
    sort: Function, 
    columnLock: Function, 
    columnUnlock: Function, 
    navigate: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/GridProps.js